module.exports = __webpack_public_path__ + "img/logo.fd0b964b.png";